import LayoutIndex from 'layouts/index'
import LayoutEmpresa from 'layouts/empresa'

//LOGIN
import EmpresaLogin from 'appsEmpresa/login/index'
import Logout from 'common/logout'

//MEU CADASTRO
import EmpresaCadastro from 'appsEmpresa/meu-cadastro/index'

//CONSULTA
import EmpresaConsulta from 'appsEmpresa/consulta/index'
import EmpresaConsultaEditar from 'appsEmpresa/consulta/editar'
import EmpresaConsultaCadastrar from 'appsEmpresa/consulta/cadastrar'

//FUNCIONARIO
import EmpresaFuncionario from 'appsEmpresa/funcionario/index'
import EmpresaFuncionarioEditar from 'appsEmpresa/funcionario/editar'
import EmpresaFuncionarioCadastrar from 'appsEmpresa/funcionario/cadastrar'
import EmpresaFuncionarioAsoAssinar from '../components/apps/funcionario/aso/assinar/index.vue'

//PERIODICOS
import EmpresaPeriodico from 'appsEmpresa/periodico/index'

//LIBERAÇÕES
import EmpresaLiberacao from 'appsEmpresa/liberacao/index'

//TEMPLATE
import _404 from 'apps/template/404'
import _511 from 'apps/template/511'
import _200 from 'apps/template/200'
import _500 from 'apps/template/500'

const routes = [
  {
    name: '404',
    path: '*',
    meta: { requiresAuth: false },
    component: _404,
  },
  {
    path: '/',
    meta: { requiresAuth: false },
    component: LayoutIndex,
    children: [
      {
        path: '',
        component: _511,
        meta: {
          requiresAuth: false,
          disablePageHeader: true,
          title: 'Cliente não Encontardo',
          navigation: [
            { text: 'Cliente não Encontardo', active: true }
          ]
        },
      },
      {
        path: '/:tenant',
        meta: { requiresAuth: false },
        component: LayoutEmpresa,
        children: [
          //LOGIN
          {
            path: '',
            component: EmpresaLogin,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Login',
              navigation: [
                { text: 'Login', active: true }
              ]
            },
          },
          {
            path: 'login',
            name: 'empresa.login',
            component: EmpresaLogin,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Login',
              navigation: [
                { text: 'Login', active: true }
              ]
            },
          },
          {
            path: 'logout',
            name: 'logout',
            component: Logout,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Sair do Sistema',
              navigation: [
                { text: 'Sair do Sistema', active: true }
              ]
            },
          },
          {
            path: 'funcionario/aso/assinar/:idConsulta',
            name: 'empresa.funcionario.aso.assinar',
            component: EmpresaFuncionarioAsoAssinar,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Assinatura de ASO',
              navigation: [
                { text: 'Assinatura de ASO', active: true }
              ]
            },
          },
          {
            path: 'funcionario/aso/assinar/:idConsulta/validacao/:step',
            name: 'empresa.funcionario.aso.assinar.step',
            component: EmpresaFuncionarioAsoAssinar,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Assinatura de ASO',
              navigation: [
                { text: 'Assinatura de ASO', active: true }
              ]
            },
          },
          //HOME
          {
            path: 'consultas',
            name: 'empresa.home',
            component: EmpresaConsulta,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Consultas',
              navigation: [
                { text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          //MEU CADASTRO
          {
            path: 'meu-cadastro',
            name: 'empresa.cadastro',
            component: EmpresaCadastro,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Meu Cadastro',
              navigation: [
                { text: 'Meu Cadastro', to: { name: 'empresa.cadastro' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          //CONSULTAS
          {
            path: 'consultas',
            name: 'empresa.consulta',
            component: EmpresaConsulta,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Consultas',
              navigation: [
                { text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          {
            path: 'consultas/editar/:consulta',
            name: 'empresa.consulta.edt',
            component: EmpresaConsultaEditar,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Editar Consulta',
              navigation: [
                { text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false },
                { text: 'Editar', to: { name: 'empresa.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
          {
            path: 'consultas/cadastrar/:funcionario?',
            name: 'empresa.consulta.cad',
            component: EmpresaConsultaCadastrar,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Cadastrar Consulta',
              navigation: [
                { text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false },
                { text: 'Cadastrar', to: { name: 'empresa.consulta.cad' }, icon: 'fa fa-plus-circle', active: true }
              ]
            },
          },
          //LIBERAÇÕES
          {
            path: 'liberacao',
            name: 'empresa.liberacao',
            component: EmpresaLiberacao,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Liberação de ASO',
              navigation: [
                { text: 'Liberação', to: { name: 'empresa.liberacao' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          //FUNCIONARIOS
          {
            path: 'funcionarios',
            name: 'empresa.funcionario',
            component: EmpresaFuncionario,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Funcionários',
              navigation: [
                { text: 'Funcionários', to: { name: 'empresa.funcionario' }, active: true }
              ]
            }
          },
          {
            path: 'funcionarios/editar/:id',
            name: 'empresa.funcionario.edt',
            component: EmpresaFuncionarioEditar,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Editar Funcionário',
              navigation: [
                { text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon:'fa fa-users', active: false },
                { text: 'Editar', to: { name: 'empresa.funcionario.edt' }, icon: 'fa fa-pencil-square-o',active: true }
              ]
            },
          },
          {
            path: 'funcionarios/cadastrar',
            name: 'empresa.funcionario.cad',
            component: EmpresaFuncionarioCadastrar,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Cadastrar Funcionário',
              navigation: [
                { text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon: 'fa fa-users', active: false },
                { text: 'Cadastrar', to: { name: 'empresa.funcionario.cad' }, icon: 'fa fa-plus-circle', active: true }
              ]
            },
          },
          //PERIODICO
          {
            path: 'periodicos',
            name: 'empresa.periodico',
            component: EmpresaPeriodico,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Periódicos',
              navigation: [
                { text: 'Periódicos', to: { name: 'empresa.periodico' }, active: true }
              ]
            }
          },
          //APROVEITAMENTO DE ASO
          {
            path: 'consulta/aproveitamento',
            name: 'empresa.aproveitamento',
            component: () => import('appsEmpresa/consulta/aproveitamento/index'),
            meta: {
              requiresAuth: true,
              title: 'Aproveitamento de ASO',
              navigation: [
                { text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, active: true }
              ]
            },
          },
          {
            path: 'consulta/aproveitamento/editar/:consulta',
            name: 'empresa.aproveitamento.edt',
            component: () => import('appsEmpresa/consulta/aproveitamento/editar'),
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Editar Aproveitamento',
              navigation: [
                { text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false },
                { text: 'Editar', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
          {
            path: 'consultas/aproveitamento/cadastrar/:funcionario?',
            name: 'empresa.aproveitamento.cad',
            component: () => import('appsEmpresa/consulta/aproveitamento/cadastrar'),
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Cadastrar Aproveitamento',
              navigation: [
                { text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false },
                { text: 'Cadastrar', to: { name: 'empresa.aproveitamento.cad' }, icon: 'fa fa-plus-circle', active: true }
              ]
            },
          },
          //ESOCIAL
          {
            path: 'esocial/gerar-xml',
            name: 'esocial.gerarXML',
            component: () => import('appsWeb/esocial/index'),
            meta: {
              requiresAuth: true,
              title: 'E-Social',
              navigation: [
                { text: 'E-Social', active: false, cs:false, to:'' },
                { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
          {
            path: 'esocial/gerar-xml-avulso',
            name: 'esocial.gerarXMLAvulso',
            component: () => import('appsWeb/esocial/avulso'),
            meta: {
              requiresAuth: true,
              title: 'E-Social Avulso',
              navigation: [
                { text: 'E-Social Avulso', active: false, cs:false, to:'' },
                { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
          {
            path: 'esocial/gerar-lote/:lote?',
            name: 'empresa',
            component: () => import('appsWeb/esocial/lotes/index'),
            meta: {
              requiresAuth: true,
              title: 'E-Social',
              navigation: [
                { text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false },
                { text: 'Gerar Lote', to: null, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
          {
            path: 'esocial/certificado',
            name: 'esocial.certificado',
            component: () => import('appsWeb/esocial/certificado/index'),
            meta: {
              requiresAuth: true,
              title: 'E-Social',
              navigation: [
                { text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false },
                { text: 'Certificado', to: null, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },

        ]
      },
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/empresa.js